import { useUnit } from 'effector-react'

import { $kpiList, $totalCountOfKPI, getKPI, kpiListMounted } from './model'
import { KPIRequest } from './types'

export const useKPIList = () => {
  const kpiList = useUnit($kpiList)
  const loading = useUnit(getKPI.pending)
  const totalCountOfKPI = useUnit($totalCountOfKPI)

  const onChangeKPIList = ({
    userIds,
    periodName,
    page,
    limit,
  }: KPIRequest) => {
    kpiListMounted({ userIds, periodName, page, limit })
  }

  return { kpiList, loading, onChangeKPIList, totalCountOfKPI }
}
